import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, ArrowRight } from 'lucide-react';

const BlogListing = () => {
  const blogPosts = [
    {
      id: -22,
      title: 'A Certified Swedish Massage in Midtown Sacramento — What the Hour Actually Looks Like',
      excerpt: 'What a certified massage therapist in midtown Sacramento does differently, and a minute-by-minute look at a Swedish session at my I Street studio.',
      date: 'June 1, 2026',
      slug: 'certified-swedish-massage-midtown-sacramento',
      image: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=1200&auto=format&fit=crop&q=80',
      category: 'Credentials & Technique',
      readTime: '9 min read'
    },
    {
      id: -21,
      title: 'Can I Get a Massage While Pregnant?',
      excerpt: 'An honest trimester-by-trimester breakdown from a California CAMTC-certified therapist — what\'s safe, when to wait, and how to talk to your provider first.',
      date: 'February 14, 2026',
      slug: 'can-i-get-a-massage-while-pregnant',
      image: 'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&auto=format&fit=crop&q=80',
      category: 'Personal Notes',
      readTime: '7 min read'
    },
    {
      id: -20,
      title: 'Should I Tip My Massage Therapist?',
      excerpt: 'A Sacramento therapist\'s honest answer — 15–20% is customary, quick math for every session length, and when tipping isn\'t expected at all.',
      date: 'February 14, 2026',
      slug: 'should-i-tip-my-massage-therapist',
      image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&auto=format&fit=crop&q=80',
      category: 'Personal Notes',
      readTime: '6 min read'
    },
    {
      id: -19,
      title: 'Swedish Massage in Sacramento, CA — A Personal Guide to Midtown & Downtown',
      excerpt: 'Where to find real Swedish massage in Sacramento — the midtown vs downtown differences, what a session feels like, and how to know it\'s what you need.',
      date: 'February 13, 2026',
      slug: 'swedish-massage-sacramento-ca-midtown-downtown',
      image: 'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&auto=format&fit=crop&q=80',
      category: 'Personal Notes',
      readTime: '8 min read'
    },
    {
      id: -18,
      title: 'How Often Should I Get a Massage?',
      excerpt: 'A California CAMTC-certified massage therapist\'s honest framework for cadence — by goal, lifestyle, and what your body\'s actually asking for.',
      date: 'February 13, 2026',
      slug: 'how-often-should-i-get-a-massage',
      image: 'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&auto=format&fit=crop&q=80',
      category: 'Personal Notes',
      readTime: '7 min read'
    },
    {
      id: -17,
      title: 'What Should I Wear to My First Massage?',
      excerpt: 'A friendly, honest first-timer guide — what to wear to the studio, what to wear on the table, and how to feel comfortable through the whole thing.',
      date: 'February 13, 2026',
      slug: 'what-should-i-wear-to-my-first-massage',
      image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=1200&auto=format&fit=crop&q=80',
      category: 'Personal Notes',
      readTime: '5 min read'
    },
    {
      id: -16,
      title: 'How Do I Know If I Need a Massage?',
      excerpt: 'The 10 signals I hear most often — plus the one that means you should probably just book. A therapist\'s honest take.',
      date: 'February 13, 2026',
      slug: 'how-do-i-know-if-i-need-a-massage',
      image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1200&auto=format&fit=crop&q=80',
      category: 'Personal Notes',
      readTime: '6 min read'
    },
    {
      id: -15,
      title: 'Is Deep Tissue Massage Supposed to Hurt?',
      excerpt: 'The honest answer: no. Here\'s what "good intensity" actually feels like, what\'s not okay, and how to communicate with your therapist.',
      date: 'February 13, 2026',
      slug: 'is-deep-tissue-massage-supposed-to-hurt',
      image: 'https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=1200&auto=format&fit=crop&q=80',
      category: 'Personal Notes',
      readTime: '6 min read'
    },
    {
      id: -14,
      title: "What's Swedish Massage in Sacramento Like?",
      excerpt: "A therapist's honest, sensory answer to what Swedish massage in Sacramento actually feels like — from the first stroke to the way you feel walking out.",
      date: 'February 13, 2026',
      slug: 'whats-swedish-massage-in-sacramento-like',
      image: 'https://images.unsplash.com/photo-1591343395902-1adcb454c4e2?w=1200&auto=format&fit=crop&q=80',
      category: 'Personal Notes',
      readTime: '7 min read'
    },
    {
      id: -13,
      title: 'Swedish Massage in Midtown Sacramento, CA — A Personal Note',
      excerpt: 'A quieter, personal note from Ayumi about what Swedish massage in midtown Sacramento actually feels like — and who it\'s really for.',
      date: 'February 13, 2026',
      slug: 'swedish-massage-midtown-sacramento-ca',
      image: 'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&auto=format&fit=crop&q=80',
      category: 'Personal Notes',
      readTime: '8 min read'
    },
    {
      id: -12,
      title: 'Back and Neck Pain Massage in Elmhurst',
      excerpt: 'Chronic back or neck pain in Elmhurst? What causes it, how targeted massage helps, and where to book — just 8–12 minutes away in midtown.',
      date: 'February 13, 2026',
      slug: 'back-and-neck-pain-massage-elmhurst',
      image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1200&auto=format&fit=crop&q=80',
      category: 'Pain Relief',
      readTime: '10 min read'
    },
    {
      id: -11,
      title: 'Back and Neck Pain Massage in Carmichael',
      excerpt: 'Live in Carmichael and dealing with chronic back or neck pain? What to do, how often to book, and where certified relief lives — minutes via Fair Oaks Blvd.',
      date: 'February 13, 2026',
      slug: 'back-and-neck-pain-massage-carmichael',
      image: 'https://images.unsplash.com/photo-1620733723572-11c53f73a416?w=1200&auto=format&fit=crop&q=80',
      category: 'Pain Relief',
      readTime: '10 min read'
    },
    {
      id: -10,
      title: 'Back and Neck Pain Massage in Arden-Arcade',
      excerpt: 'Arden-Arcade residents dealing with back or neck pain — what causes it, how massage actually helps, and how to book minutes away in midtown.',
      date: 'February 13, 2026',
      slug: 'back-and-neck-pain-massage-arden-arcade',
      image: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=1200&auto=format&fit=crop&q=80',
      category: 'Pain Relief',
      readTime: '10 min read'
    },
    {
      id: -9,
      title: 'Back and Neck Pain Massage in The Pocket',
      excerpt: 'From The Pocket, real back and neck pain relief is a quick I-5 drive north. What to expect, how often to book, and how certified massage helps.',
      date: 'February 13, 2026',
      slug: 'back-and-neck-pain-massage-the-pocket',
      image: 'https://images.unsplash.com/photo-1590212151175-e58edd96185b?w=1200&auto=format&fit=crop&q=80',
      category: 'Pain Relief',
      readTime: '10 min read'
    },
    {
      id: -8,
      title: 'Back and Neck Pain Massage in Oak Park',
      excerpt: 'Chronic back or neck pain in Oak Park? Why it happens, what to expect from a real pain-focused session, and how to book minutes away in midtown.',
      date: 'February 13, 2026',
      slug: 'back-and-neck-pain-massage-oak-park',
      image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1200&auto=format&fit=crop&q=80',
      category: 'Pain Relief',
      readTime: '10 min read'
    },
    {
      id: -7,
      title: 'East Sacramento Massage Therapist: The 2026 Local Guide',
      excerpt: 'Looking for an East Sacramento massage therapist? Where residents of the Fab 40s, River Park & McKinley Park book — just minutes west in midtown.',
      date: 'February 13, 2026',
      slug: 'east-sacramento-massage-therapist',
      image: 'https://images.unsplash.com/photo-1591343395902-1adcb454c4e2?w=1200&auto=format&fit=crop&q=80',
      category: 'Neighborhood Guide',
      readTime: '10 min read'
    },
    {
      id: -6,
      title: 'Land Park Massage Therapist: The 2026 Local Guide',
      excerpt: 'Looking for a Land Park massage therapist? Where certified options are, what to expect, and how to book with Ayumi Suzuki — 8–12 minutes north in midtown.',
      date: 'February 13, 2026',
      slug: 'land-park-massage-therapist',
      image: 'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&auto=format&fit=crop&q=80',
      category: 'Neighborhood Guide',
      readTime: '10 min read'
    },
    {
      id: -5,
      title: 'Curtis Park Massage Therapist: The 2026 Local Guide',
      excerpt: 'Looking for a Curtis Park massage therapist? Where to find certified options, what to look for, and how to book with Ayumi Suzuki — just minutes north in midtown.',
      date: 'February 13, 2026',
      slug: 'curtis-park-massage-therapist',
      image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=1200&auto=format&fit=crop&q=80',
      category: 'Neighborhood Guide',
      readTime: '10 min read'
    },
    {
      id: -4,
      title: 'The Best Time of Year to Start Regular Massage Therapy',
      excerpt: 'Wondering when to begin a regular massage routine? A season-by-season guide to the real benefits of starting in winter, spring, summer, or fall.',
      date: 'February 13, 2026',
      slug: 'best-time-of-year-to-start-regular-massage-therapy',
      image: 'https://images.unsplash.com/photo-1620733723572-11c53f73a416?w=1200&auto=format&fit=crop&q=80',
      category: 'Wellness Habits',
      readTime: '9 min read'
    },
    {
      id: -3,
      title: 'Certified Massage Therapist in Midtown Sacramento & the Surrounding Area',
      excerpt: 'What California certification actually means, how to verify it, the neighborhoods served, and how to book a session with certified therapist Ayumi Suzuki.',
      date: 'February 13, 2026',
      slug: 'certified-massage-therapist-midtown-sacramento',
      image: 'https://images.unsplash.com/photo-1591343395082-e120087004b4?w=1200&auto=format&fit=crop&q=80',
      category: 'Credentials & Trust',
      readTime: '11 min read'
    },
    {
      id: -2,
      title: 'Deep Tissue vs Swedish Massage in Mid-Town Sacramento: Which One Should You Book?',
      excerpt: 'Trying to decide between deep tissue and Swedish massage in mid-town Sacramento? This 2026 guide breaks down the real differences in pressure, technique, benefits, and use cases.',
      date: 'February 13, 2026',
      slug: 'deep-tissue-vs-swedish-massage-midtown-sacramento',
      image: 'https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=1200&auto=format&fit=crop&q=80',
      category: 'Massage Techniques',
      readTime: '10 min read'
    },
    {
      id: -1,
      title: 'Massage Therapy Mid-Town Sacramento: The Local 2026 Guide',
      excerpt: 'A complete local 2026 guide to massage therapy in mid-town Sacramento — techniques, what to expect, pricing, parking, scheduling tips, and how to book at 2528 I Street.',
      date: 'February 13, 2026',
      slug: 'massage-therapy-midtown-sacramento',
      image: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=1200&auto=format&fit=crop&q=80',
      category: 'Local Wellness',
      readTime: '12 min read'
    },
    {
      id: 0,
      title: 'Healing Massage Therapy in Mid-Town Sacramento: A 2026 Guide to Restorative Bodywork',
      excerpt: 'A complete 2026 guide to healing massage therapy in mid-town Sacramento — what it is, who benefits, what to expect, pricing, and how to book at Ayumi Suzuki\'s mid-town practice.',
      date: 'February 13, 2026',
      slug: 'healing-massage-therapy-midtown-sacramento',
      image: 'https://images.squarespace-cdn.com/content/v1/68ebb6751f9d04372e40f528/1761329558856-2WNFM7KJRJH0TIZ1NX5U/unsplash-image-3aGV2ViCzrM.jpg',
      category: 'Healing & Recovery',
      readTime: '11 min read'
    },
    {
      id: 1,
      title: 'Finding Your Perfect Downtown Sacramento Massage Therapist: A Complete Local Guide',
      excerpt: 'Navigate downtown Sacramento\'s vibrant wellness scene and discover how to find a skilled, certified massage therapist who meets your unique needs.',
      date: 'January 5, 2025',
      slug: 'downtown-sacramento-massage-therapist',
      image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1200&auto=format&fit=crop&q=80',
      category: 'Local Business',
      readTime: '12 min read'
    },
    {
      id: 2,
      title: 'The Complete Guide to Massage Therapy in Sacramento: Benefits, Types, and Finding the Right Therapist',
      excerpt: 'Discover how therapeutic massage can transform your health and wellness journey in Sacramento\'s thriving wellness community.',
      date: 'January 2, 2025',
      slug: 'massage-therapy-sacramento',
      image: 'https://images.squarespace-cdn.com/content/v1/68ebb6751f9d04372e40f528/1dd40389-4a04-4c39-9d96-f322e19b4d5f/unsplash-image-WAm_HaI4W2E.jpg',
      category: 'Health & Wellness',
      readTime: '10 min read'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-rose-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-teal-600 to-teal-700 text-white py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <Link 
            to="/"
            className="inline-flex items-center space-x-2 text-white/90 hover:text-white transition-colors duration-300 group mb-6"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-300" />
            <span>Back to Home</span>
          </Link>
          <h1 className="text-5xl md:text-6xl font-serif mb-4">Wellness Blog</h1>
          <p className="text-xl text-teal-100">Expert insights on massage therapy, wellness, and health in Sacramento</p>
        </div>
      </div>

      {/* Blog Posts Grid */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link
          to="/massage-midtown-sacramento"
          className="group mb-12 flex flex-col md:flex-row md:items-center justify-between gap-4 bg-gray-900 text-white rounded-2xl p-8 hover:bg-teal-800 transition-colors duration-300"
          data-testid="blog-midtown-studio-banner"
        >
          <div>
            <p className="text-xs uppercase tracking-widest text-teal-300">Midtown Sacramento · 2528 I Street</p>
            <p className="mt-2 text-2xl font-serif">Visiting the Midtown studio? Map, parking, hours & pricing</p>
          </div>
          <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform duration-300" />
        </Link>
        <div className="grid md:grid-cols-2 gap-8">
          {blogPosts.map((post) => (
            <article
              key={post.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              <Link to={`/blog/${post.slug}`}>
                <div className="aspect-video overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </Link>
              
              <div className="p-8">
                <div className="flex items-center gap-4 text-sm text-gray-600 mb-4">
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-xs font-medium">
                    {post.category}
                  </span>
                  <span className="flex items-center">
                    <Calendar className="w-4 h-4 mr-2" />
                    {post.date}
                  </span>
                  <span>{post.readTime}</span>
                </div>

                <Link to={`/blog/${post.slug}`}>
                  <h2 className="text-2xl font-serif text-gray-800 mb-4 hover:text-teal-600 transition-colors duration-300 leading-tight">
                    {post.title}
                  </h2>
                </Link>

                <p className="text-gray-600 mb-6 leading-relaxed">
                  {post.excerpt}
                </p>

                <Link
                  to={`/blog/${post.slug}`}
                  className="inline-flex items-center text-teal-600 hover:text-teal-700 font-medium group"
                >
                  Read Full Article
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
                </Link>
              </div>
            </article>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-center text-white">
          <h2 className="text-3xl font-serif mb-4">Ready to Experience Professional Massage Therapy?</h2>
          <p className="text-xl text-teal-100 mb-8">
            Book your appointment with Ayumi Suzuki today and discover the transformative power of expert massage therapy in midtown Sacramento.
          </p>
          <Link
            to="/book"
            className="inline-block bg-white text-teal-700 px-10 py-4 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-300"
          >
            Schedule Your Appointment
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogListing;